import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

import Theme from '../common/NekoTheme';

const NekoH1 = Styled.h1`
  font-family: ${Theme.fontFamily};
  font-weight: normal;
  font-size: ${Theme.fontSizeH1};
  line-height: normal;
  margin-top: 0;
  margin-bottom: 16px;
  padding: 0;
`;

const NekoH2 = Styled.h2`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeH2};
  font-weight: normal;
  line-height: normal;
  margin-top: 0;
  margin-bottom: 16px;
  padding: 0;
`;

const NekoP = Styled.p`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  line-height: normal;
  margin: 16px 0 24px;
  padding: 0;
`;

const NekoSpan = Styled.span`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  line-height: normal;
  margin: 0;
  padding: 0;
`;

const NekoLabel = Styled.label`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  line-height: normal;
  margin: 0;
  padding: 0;
`;

/**
 * @param {string} (variant) Tag Name
 */
const StyledNekoTypo = props => {
  const { children, ...rest } = props;

  return (
    props.h1 ? <NekoH1 {...rest}>{children}</NekoH1>
    : props.h2 ? <NekoH2 {...rest}>{children}</NekoH2>
    : props.p ? <NekoP {...rest}>{children}</NekoP>
    : props.label ? <NekoLabel {...rest}>{children}</NekoLabel>
    : <NekoSpan {...rest}>{children}</NekoSpan>
  );
};

const NekoTypo = (props) => {
  return (<StyledNekoTypo {...props} />);
}

NekoTypo.propTypes = {
  h1: PropTypes.any,
  h2: PropTypes.any,
  p: PropTypes.any
};

NekoTypo.defaultProps = {
  h1: undefined,
  h2: undefined,
  p: undefined
};

export { NekoTypo };
